import { UserManager, WebStorageStateStore, User, Log } from "oidc-client";
import _ from "lodash";
import ajax from "../lib/ajax";
import Util from "../lib/util";
import AppConsts from "@/lib/appconst";

class AuthService {
  private userManager: UserManager;

  constructor() {
    const STS_DOMAIN: string = AppConsts.isUrl;
    const settings: any = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: STS_DOMAIN,
      client_id: "wms",
      redirect_uri: `${AppConsts.appBaseUrl}callback.html`,
      automaticSilentRenew: true,
      silent_redirect_uri: `${AppConsts.appBaseUrl}silent-renew.html`,
      response_type: "code",
      scope: "openid profile email roles",
      post_logout_redirect_uri: AppConsts.appBaseUrl,
      filterProtocolClaims: true,
    };
    Log.logger = console;
    Log.level = Log.DEBUG;
    this.userManager = new UserManager(settings);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public silentLogin(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public silentLoginCallback(): Promise<User> {
    return this.userManager.signinSilentCallback();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public silentLogout(): Promise<any> {
    return Promise.all([this.userManager.clearStaleState(), this.userManager.removeUser(), this.userManager.revokeAccessToken()]);
  }

  public getAccessToken(): Promise<string> {
    return this.userManager.getUser().then((data: any) => {
      return _.get(data, "access_token");
    });
  }
};
const auth = new AuthService();
globalThis.auth = auth;
export default auth;
